import React, { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'

function LoginPage() {
  const { user, signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  // Already signed in — go to dashboard
  if (user) return <Navigate to="/" replace />

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const { error: signInError } = await signIn(email, password)

    if (signInError) {
      setError('Invalid email or password.')
      setLoading(false)
    }
    // On success, onAuthStateChange updates user state and Navigate above redirects
  }

  const inputStyle = (hasError) => ({
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: hasError ? '2px solid #ef4444' : '2px solid #374151',
    backgroundColor: '#111827',
    color: 'white',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box',
  })

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#111827',
      backgroundImage: 'radial-gradient(ellipse at 50% 0%, rgba(250,204,21,0.08) 0%, transparent 60%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        backgroundColor: '#1f2937',
        borderRadius: '16px',
        border: '1px solid rgba(255,255,255,0.07)',
        padding: '40px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
      }}>
        {/* Logo + title */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img
            src="/logo.jpg"
            alt="Smart Media Group"
            style={{ height: '60px', margin: '0 auto 16px', borderRadius: '8px', border: '2px solid rgba(250,204,21,0.3)' }}
          />
          <h1 style={{ color: 'white', fontSize: '24px', fontWeight: '700', margin: '0 0 8px 0', letterSpacing: '-0.02em' }}>
            Client Management
          </h1>
          <p style={{ color: '#9ca3af', margin: 0, fontSize: '14px' }}>
            Sign in with your account
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#9ca3af', fontSize: '14px', marginBottom: '6px' }}>
              Email address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoFocus
              style={inputStyle(!!error)}
              onFocus={(e) => { e.target.style.borderColor = '#FACC15' }}
              onBlur={(e) => { e.target.style.borderColor = error ? '#ef4444' : '#374151' }}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#9ca3af', fontSize: '14px', marginBottom: '6px' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={inputStyle(!!error)}
              onFocus={(e) => { e.target.style.borderColor = '#FACC15' }}
              onBlur={(e) => { e.target.style.borderColor = error ? '#ef4444' : '#374151' }}
            />
          </div>

          {/* Error message */}
          {error && (
            <p style={{ color: '#ef4444', fontSize: '14px', margin: '0 0 16px 0', textAlign: 'center' }}>
              {error}
            </p>
          )}

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: loading ? '#a16207' : '#FACC15',
              color: '#111827',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.15s',
            }}
            onMouseEnter={(e) => { if (!loading) e.target.style.backgroundColor = '#EAB308' }}
            onMouseLeave={(e) => { if (!loading) e.target.style.backgroundColor = '#FACC15' }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <p style={{ textAlign: 'center', margin: '16px 0 0' }}>
            <Link
              to="/auth/forgot-password"
              style={{ color: '#9ca3af', fontSize: '14px', textDecoration: 'none' }}
            >
              Forgot password?
            </Link>
          </p>
        </form>
      </div>
    </div>
  )
}

export default LoginPage
